import React, { useEffect, useRef, useState, useContext } from "react";

import styled from "styled-components";

import { loginToTwitch, loginToYoutube } from "../../../utils/loginHelper";
import {UserContext} from '../../../utils/userDetailsProvider';

import YoutubeIcon from '../../../assets/youtube_icon.svg';
import TwitchIcon from '../../../assets/twitch_icon.svg';


const ConnectButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  height: 45px;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 12px;
`

const ConnectButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  border-radius: 12px;
`

const customStyles = {
  content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
  },
};

const ConnectButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export default function LoginButtonsComponent(props){

    let width = '100%';
    const userDetails = useContext(UserContext);
    let deviceType = userDetails.isMobile?'mobile':'web';
    console.log('deviceType', deviceType);
    
    const handleConnectTwitchClicked = ()=>{
	loginToTwitch()
    }

    const handleConnectYoutubeClicked = ()=>{
	loginToYoutube()
    }
        
    return (
        <>
            <ConnectButtonContainer>
                <ConnectButtonDiv
                    style={{
                        background: 'linear-gradient(95.39deg, #FE0000 3.78%, #FA00FF 100%)',
                        marginBottom:10,
                        width:width
                    }}
                    onClick={()=>{
                        handleConnectYoutubeClicked();
                        window.analytics.track('connect_twitch_button_pressed', {
                            from: 'TopCardComponent',
                            type: deviceType
                        }) 
                    }}>
                    <img src={YoutubeIcon} style={{
                        marginRight:14,
                        width: 29,
                        height: 20
                    }} />
                    <ConnectButtonTextSpan>
                        LOG IN WITH YOUTUBE
                    </ConnectButtonTextSpan>
                </ConnectButtonDiv>
                <ConnectButtonDiv
                    style={{
                        background: ' linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%)',
                        width:width
                    }}
                    onClick={()=>{
                        handleConnectTwitchClicked();
                        window.analytics.track('connect_twitch_button_pressed', {
                            from: 'TopCardComponent',
                            type: deviceType
                        }) 
                    }}>
                    <img src={TwitchIcon} style={{
                        marginRight:23,
                        width: 20,
                        height: 24,
                        marginLeft:-12
                    }} />
                    <ConnectButtonTextSpan>
                        LOGIN WITH TWITCH
                    </ConnectButtonTextSpan>
                </ConnectButtonDiv>
            </ConnectButtonContainer>
        </>
    );

}
